module.exports = __webpack_public_path__ + "img/countries.ae50c70a.svg";